import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { setLeadsFilterValue } from "../store/action-creators";
import type { LeadsSearchAllFiltersTypes } from "../types/leadsSearchFilters.dto";
import { leadsFilterPanelValueToDto } from "../utils/leadsFilterDtoAdapters";

type FiltersUpdateFn = (filters: Partial<LeadsSearchAllFiltersTypes>) => void;

/** Folds a flat panel value into the DTO and replaces the leads filter state with it. */
export const useFiltersUpdate = (): FiltersUpdateFn => {
    const dispatch = useDispatch();

    return useCallback(
        (filters) => {
            dispatch(setLeadsFilterValue(leadsFilterPanelValueToDto(filters)));
        },
        [dispatch],
    );
};
